import { provideEnvironmentInitializer, inject } from '@angular/core';
import { TabSyncService } from '@core/services/auth/tab-sync.service';

export const provideTabSync = () => {
  return provideEnvironmentInitializer(() => {
    inject(TabSyncService);
  });
};
